import React, { useState } from "react";

// Small inline reason-collection form - originally built inline in
// LpoDetail.jsx for Reject/Cancel, now shared by every Delete action added
// in Batch44 (Stock-In/Out/Return/Adjustment) so the interaction doesn't get
// rebuilt four more times.
const ReasonPrompt = ({ label, onConfirm, onCancel, confirmLabel = "Confirm", confirmVariant = "danger", required = true }) => {
  const [reason, setReason] = useState("");
  return (
    <div className="card mb-3">
      <div className="card-body">
        <label className="form-label">{label}</label>
        <textarea className="form-control mb-2" rows={2} value={reason} onChange={(e) => setReason(e.target.value)} />
        <div className="d-flex gap-2">
          <button
            type="button"
            className={`btn btn-${confirmVariant}`}
            onClick={() => onConfirm(reason)}
            disabled={required && !reason.trim()}
          >
            {confirmLabel}
          </button>
          <button type="button" className="btn btn-secondary" onClick={onCancel}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default ReasonPrompt;
